// src/components/shared/VideoHero.js

import React, { useState } from 'react';

const VideoHero = ({ title, mainText, tagline }) => {
  const [isVideoLoaded, setIsVideoLoaded] = useState(false);

  return (
    <section className="community-hero">
      <video
        autoPlay
        loop
        muted
        playsInline
        className={`community-hero-video ${isVideoLoaded ? 'loaded' : ''}`}
        poster="/videos/herovideo-poster.jpg"
        onCanPlay={() => setIsVideoLoaded(true)}
        preload="metadata"
      >
        <source src="/videos/herovideo.webm" type="video/webm" />
        <source src="/videos/herovideo.mp4" type="video/mp4" />
        Tarayıcınız video etiketini desteklemiyor.
      </video>

      <div className="community-hero-content">
        {/* GÜNCELLENDİ: Yeni ve daha zengin metin yapısı */}
        {title && <h1 className="video-hero-title">{title}</h1>}
        {mainText && <p className="video-hero-maintext">{mainText}</p>}
        {tagline && <p className="video-hero-tagline">{tagline}</p>}
      </div>
    </section>
  );
};

export default VideoHero;